'use strict';
const angular = require('angular');

export function datatablesStateService($localStorage, $location) {
  'ngInject';

  const BASE_KEY = "DTState$";

  if (!$localStorage.dtState)
    $localStorage.dtState = {};

  return {

    save(key) {
      let SAVE_KEY = BASE_KEY;
      if (key) {
        SAVE_KEY += key + "$";
      }
      SAVE_KEY += $location.url();

      return (settings, data) => {
        $localStorage.dtState[SAVE_KEY] = data;
      }
    },

    restore(key) {
      let RESTORE_KEY = BASE_KEY;
      if (key) {
        RESTORE_KEY += key + "$";
      }
      RESTORE_KEY += $location.url();

      return (settings, callback) => {
        if ($localStorage.dtState && $localStorage.dtState[RESTORE_KEY]) {
          callback($localStorage.dtState[RESTORE_KEY]);
        } else {
          callback({});
        }
      }
    }
  };
}


export default angular.module('conduu.datatablesState', [])
  .factory('DTState', datatablesStateService)
  .name;



// WEBPACK FOOTER //
// ./client/components/datatables-state/datatables-state.service.js